<template>
<v-container>

    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-row>

        <v-col cols="12">
            <base-material-card color="primary" icon="library_books" title="Administrar Clientes" class="px-5 py-3">
                <v-card-actions>
                    <v-spacer></v-spacer>
                        
                        <v-btn v-if="permiso_edicion" fab dark x-small color="secondary" slot="activator" @click.native="openmodal()" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>
                 </v-card-actions>        
                <v-card-text class="pa-0">
                
                    <div id="datagrid" v-on:keyup.enter="$refs.pagination_pw.filterData()">

                        <v-client-table ref="vuetable" id="lista_clientes" :data="clientes.items" :columns="columns" :options="options" class="elevation-2 pa-2">
                            <template slot="noResults">
                                <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                            </template>
                             <template slot="options" slot-scope="props" >
                                   

                                        <v-btn v-if="permiso_edicion" x-small fab dark color="pink" @click.native="delCliente(props.row.rfc)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                   
                                </template>
                        </v-client-table>
                        <template>
                            <div v-if="pwPagination.total > 0">
                                <div class="mt-3">
                                    <PaginacionComponent ref="pagination_pw" :total='pwPagination.total' :links="pwPagination.links" :items="clientes" :options="pwPagination.options"></PaginacionComponent>
                                </div>
                            </div>
                        </template>
                    </div>

                </v-card-text>

            </base-material-card>
        </v-col>

    </v-row>
    <v-dialog v-model="modal" max-width="60%">
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal">
                    <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>
                    <span class="subheading">
                        <strong>Agregar Cliente</strong>
                    </span>
                </v-card>
            </v-card-title>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container grid-list-md>
                        <v-row>
                            <v-col cols=6>
                                <v-text-field label="RFC del Cliente" v-model="model.rfc" 
                                @input="model.rfc = model.rfc.toString().toUpperCase()" 
                                :rules="[rules.required]"></v-text-field>
                            </v-col>
                       </v-row>
                       <v-row>
                            <v-col cols=6>
                                <v-text-field label="Nombre del Cliente" v-model="model.nombre"                                 
                                :rules="[rules.required]"></v-text-field>
                            </v-col>
                       </v-row>
                       <v-row>
                            <v-col cols=6>
                                <v-text-field label="Metadato" v-model="model.metadato" :rules="[rules.required]"></v-text-field>
                            </v-col>
                       </v-row>
                    </v-container>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="modal = false">
                    <v-icon>cancel</v-icon> Cancelar
                </v-btn>
                <v-btn color="success" @click.native="addCliente()">
                    <v-icon>done</v-icon> Agregar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import PaginacionComponent from '@/components/PaginacionComponent.vue';

export default {
    created: function () {
    
    },
    mounted: function () {
       
        this.mostrarmenu()
        this.carga_clientes();
        this.model_filters = this.$refs.vuetable.query
    },
    watch: {
        model_filters: {
            handler(val) {
                this.pwPagination.options.filters = {
                    usuario: this.$local_storage.get("id_usuario"),
                    sistema: this.$sistema,
                    filtros: {
                        nombre__icontains: this.model_filters.razon,
                        identificador__icontains: this.model_filters.rfc,
                        fecha_ingreso__icontains: this.model_filters.fecha_ingreso,
                        fecha_vencimiento__icontains: this.model_filters.fecha_vencimiento
                    }
                }
            },
            deep: true
        }
    },
    computed: {
        computeLogo() {
            return "/static/logo_blanco.png";
        },
      
        permiso_edicion(){
            return (
               this.valida_permiso("Emanifiesto.catalogos.clientes.crear") || 
               this.valida_permiso("EmanifiestoAA.catalogos.clientes.crear") ||
               //(23-06-2023): Humberto solicita que el agente admin si pueda crear usuarios y clientes
               this.$local_storage.get("es_agente") == 1 
            );
    }
    },
    components: {
        "PaginacionComponent": PaginacionComponent
    },
    methods: {
         valida_permiso(permiso) {
          return (
              this.$local_storage.get(permiso) == 100 || this.$local_storage.get("tipo_usuario") == "Super Usuario"
            );
        },
        openmodal(){
            this.model.rfc = "";
            this.model.nombre= "";
            this.model.metadato= "";
            this.modal=true;
        },
        carga_clientes: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = {
                id_grupo: this.$local_storage.get("id_grupo"),
            };

            var url = this.$hostname + "grupos/get_rfcs/";

            var self = this;
            axios
                .post(url, data)
                .then(function (response) {
                    console.log(response);
                    if(response.data != undefined) {
                        self.clientes.items = response.data;
                        self.pwPagination.total = response.data.count;
                        self.pwPagination.links.next = response.data.next;
                        self.pwPagination.links.prev = response.data.previous;
                    }else
                        self.clientes.items = [];
                    

                    self.$root.$dialogLoader.hide();
                })
                .catch(function (error) {

                    console.log(error);
                    self.$root.$dialogLoader.hide();

                });
        },
        getCliente: function (id) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.sistemas = [];
            this.model.modulos = [];
            axios
                .get(this.$hostname + "clientes/" + id + "/")
                .then(response => {

                    this.model.id_cliente = response.data.id_cliente;
                    this.model.nombre = response.data.nombre;
                    this.model.grupo = response.data.grupo;
                    this.model.anio_recuperacion = response.data.anio_recuperacion;
                    this.model.tipos_empresa = response.data.tipos_empresa;
                    this.model.guardar_peticiones = response.data.guardar_peticiones;
                    this.model.consultas_anteriores = response.data.consultas_anteriores;
                    this.model.dias_cliente = response.data.dias_cliente;
                    this.getSistemasCliente();
                })
                .catch(error => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el cliente",
                        footer: ""
                    });
                });
        },
        addCliente: function () {
             if (this.$refs.form.validate()) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let id_modulo = 14;
            if(this.$local_storage.get("es_transportista")==1 ){
                id_modulo = 13;    
            }

            
            var data = {
                id_grupo: this.$local_storage.get("id_grupo"),
                rfc: this.model.rfc,
                razon_social: this.model.nombre,
                metadato:  this.model.metadato,
                id_modulo: id_modulo,
            };

            var url = this.$hostname + "grupos/save_rfc/";

            var self = this;
            axios
                .post(url, data)
                .then(function (response) {
                    console.log(response);
                    if(response.statusText == "OK"){
                        
                         self.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El Cliente se agrego correctamente.",
                            footer: ""
                        });
                        self.carga_clientes();
                    }
                    
                    self.$root.$dialogLoader.hide();
                    self.modal = false;
                })
                .catch(function (error) {

                    console.log(error);
                    self.$root.$dialogLoader.hide();

                });
             }
        },
        delCliente: function (rfc) {
            
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var data = {
                id_grupo: this.$local_storage.get("id_grupo"),
                rfc: rfc
            };

            var url = this.$hostname + "grupos/delete_rfc/";

            var self = this;
            axios
                .post(url, data)
                .then(function (response) {
                    if(response.statusText == "OK"){
                        
                         self.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El Cliente se eliminó del grupo correctamente.",
                            footer: ""
                        });
                        self.carga_clientes();
                    }
                    self.$root.$dialogLoader.hide();
                    
                })
                .catch(function (error) {

                    console.log(error);
                    self.$root.$dialogLoader.hide();

                });
             
        },
        updateCliente: function () {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                let id_cliente = this.model.id_cliente;
                let peticiones = 0;
                let anteriores = 0;

                if (this.model.guardar_peticiones == 1 || this.model.guardar_peticiones == "1" || this.model.guardar_peticiones == true) {
                    peticiones = 1;
                }

                if (this.model.consultas_anteriores == 1 || this.model.consultas_anteriores == "1" || this.model.consultas_anteriores == true) {
                    anteriores = 1;
                }

                let datos = {
                    grupo: this.model.grupo,
                    nombre: this.model.nombre,
                    sistemas: this.model.sistemas,
                    anio_recuperacion: this.model.anio_recuperacion,
                    tipos_empresa: this.model.tipos_empresa,
                    guardar_peticiones: peticiones,
                    consultas_anteriores: anteriores,
                    dias_cliente: this.model.dias_cliente,
                    modulos: this.obtenerModulosSeleccionados()
                };

                axios
                    .put(this.$hostname + "clientes/" + this.model.id_cliente + "/", datos)
                    .then(response => {
                        this.modal = false;

                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El Cliente se actualizó correctamente.",
                            footer: ""
                        });

                        this.getClientes();
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los grupos.",
                            footer: ""
                        });
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                    });
            }
        },

        mostrarmenu: function (val) {
            //Se actualiza la variable store.state.datetime para forzar a recargar el componente de AppBar.vue
            //Esta variable se manda llamar en el archivo App.vue
            this.$store.state.datetime = moment(new Date()).format("x"); //Unix timestamp
        },

    },

    data() {
        return {
            modal: false,
            model_filters: '',
            pwPagination: {
                total: 0,
                links: {
                    url: this.$hostname + "grupos/save_rfc/",
                    next: '',
                    prev: '',
                },
                options: {
                    tipo: 1,
                    size: 10,
                    loading: this.showLoading,
                    filters: {}
                }
            },
            rules: {
                required: v => !!v || "Este campo es requerido",
                numeric: v => Number.isInteger(parseInt(v)) || "El campo debe ser un numero"
            },
            model: {
                id_cliente: "",
                nombre: "",
                metadato: "",
                grupo: "",
                sistemas: [],
                modulos: [],
                anio_recuperacion: 2012,
                tipos_empresa: "",
                guardar_peticiones: 0,
                consultas_anteriores:0,
                dias_cliente:30,
            },
            name: "datagrid",
            columns: [ "rfc", "razon_social", "metadato", 'options'],
            options: {
                filterable: ["rfc", "razon_social", "metadato"],
                sortable: ["rfc", "razon_social", "metadato",],
                headings: {
                    rfc: "RFC o TAX ID",
                    razon: "Razón Social",
                    metadato: "Metadato",
                    options: "Operaciones"
                },
                filterAlgorithm: {
                    rfc: function () {
                        return true;
                    },
                    razon: function () {
                        return true;
                    },
                    metadato: function () {
                        return true;
                    }
                },
            },
            
             breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext",
            }, {
                    text: "Clientes",
                    disabled: true,
                    href: ""
                }
            ],
            search: "",
            show_loading: true,
            lista_clientes: [],
            clientes: {
                selected: [],
                headers: [{
                        text: "",
                        value: "icon"
                    },
                    {
                        text: "RFC ",
                        value: "rfc"
                    },
                    {
                        text: "RAZÓN SOCIAL ",
                        value: "razon"
                    },
                    {
                        text: "METADATO",
                        value: "metadato"
                    }
                ],
                items: [0]
            }
        };
    }
};
</script>